import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api } from './api';
import styles from './Login.module.css'; // Solo este archivo
import logo from './logo2.png'; // Asegúrate de que la ruta sea correcta

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    
    try {
      console.log('Intentando login con:', username);
      const response = await api.login(username, password);
      
      console.log('Respuesta del servidor:', response);
      
      if (response.error) {
        setError(response.error);
        setLoading(false);
        return;
      }

      if (response.success && response.token) {
        console.log('Login exitoso, token:', response.token.substring(0, 10) + '...');
        console.log('Usuario:', response.user);
        
        // Redireccionar según el rol del usuario
        const userRole = response.user.rol || 'administrador';
        console.log('Rol del usuario:', userRole);
        
        if (userRole === 'administrador' || userRole === 'encargado_de_sector') {
          navigate('/admin');
        } else if (userRole === 'afiliado') {
          navigate('/afiliado');
        } else {
          navigate('/admin');
        }
      } else {
        setError('Respuesta inválida del servidor');
        console.error('Respuesta:', response);
      }
    } catch (err) {
      setError('Error en la conexión. Intenta más tarde.');
      console.error('Error:', err);
    }
    setLoading(false);
  };

  return (
    <div className={styles.loginContainer}>
      <img src={logo} alt="App Logo" className={styles.appLogo} />
      <form onSubmit={handleSubmit} className={styles.loginForm}>
        <div>
          <label>Correo: </label>
          <input
            type="email"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            required
          />
        </div>
        <div>
          <label>Contraseña: </label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />
        </div>
        {error && <p className={styles.error}>{error}</p>}
        <button type="submit">Inicio sesión</button>
      </form>
    </div>
  );
}

export default Login;
